"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledFormControl = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
// This is currently only used to prevent non-native attributes from going to the DOM
var StyledFormControl = /*#__PURE__*/_styledComponents.default.input.withConfig({
  displayName: "StyledFormControl",
  componentId: "c11n-8-107-0__sc-w61kvv-0"
})([""]);
exports.StyledFormControl = StyledFormControl;